$(document).ready(function () {
    let emergencyPopup = $('.emergency-popup');

    if (emergencyPopup) {
        let closebutton = emergencyPopup.find('.emergency-popup__close');

        if (closebutton) {
            $(closebutton).on('click', function () {
                $.cookie('emergency-popup-viewed', 'True', { expires: 1 });
                emergencyPopup.hide();
            });
        }
    }
});